import { Col, Row, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { initialState, reducer } from "./reducer";
import { isValidValue } from "../../../../helpers/FormHelper";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";
import Search from "./components/Search";
import List from "./components/List";
import DiasporaReferenceService from "../../../../services/Diaspora/DiasporaReferenceService";
import { setRowNumber } from "../../../../helpers/MainHelper";



const hasAppliedFilters = (filters) => {
    if (filters.name === null && filters.surname === null)
        return false;

    return true;
};



const SelectVoter = ({ selectVoter, onClose }) => {
    const token = useSelector((state) => state.Member.token);
    const [state, dispatch] = useReducer(reducer, initialState);
    const [errorMessage, setErrorMessage] = useState(null);
    const loadingTypeReference = useRef(null);


    useEffect(() => {
        const hasFilters = hasAppliedFilters(state.filters.searchFilters);
        if (hasFilters === false) {
            setErrorMessage('Për të zgjedhur votuesin, ju lutem më parë kërkoni sipas filtrave përkatëse!')
            updateItems([], 0);
            return;
        };

        const fetchMembers = async () => {
            try {
                updateLoading(true);
                const response = await DiasporaReferenceService.searchVoter(token, state.filters.searchFilters);
                const responseData = response.data;
                if (responseData) {
                    const itemsList = setRowNumber(responseData);
                    const itemsCount = itemsList?.length;
                    updateItems(itemsList, itemsCount);
                    setErrorMessage(null);
                } else {
                    setErrorMessage('Një gabim ndodhi gjatë komunikimit me serverin!');
                    updateItems([], 0);
                }
            } catch (error) {
                const errorMessage = getErrorMessage(error);
                setErrorMessage(errorMessage);
                updateItems([], 0);
            } finally {
                updateLoading(false);
            }
        };

        fetchMembers();
    }, [token, state.filters.searchFilters, state.filters.refreshIndex]);


    const updateItems = (itemsList, itemsCount) => {
        const action = {
            type: "set_items",
            payload: {
                items: itemsList,
                total: itemsCount,
            },
        };
        dispatch(action);
    };


    const updateLoading = (isLoading) => {
        const loadingType = loadingTypeReference.current;
        const action = {
            type: isValidValue(loadingType) ? `set_${loadingType}_loading` : 'set_loading',
            payload: isLoading,
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24} className="m-0 mb-3" style={{ backgroundColor: "#F5F5F5" }}>
                    <Col span={24}>
                        <Row gutter={24} className="p-2" align="middle">
                            <Col xl={4} lg={4} md={4} sm={4} xs={4} />
                            <Col xl={16} lg={16} md={16} sm={16} xs={16} className="text-center">
                                <h4 className="font-weight-bold m-0 p-0">
                                    Kërkoni dhe zgjidhni votuesin
                                </h4>
                            </Col>
                            <Col xl={4} lg={4} md={4} sm={4} xs={4} className="text-right p-0">
                                <Button
                                    type="primary"
                                    style={{ color: "#000000", backgroundColor: "#F5F5F5", borderColor: "#F5F5F5", boxShadow: 'none' }}
                                    icon={<CloseOutlined />}
                                    onClick={onClose}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={24} className="mb-3">
                    <Col span={24}>
                        <Search
                            dispatch={dispatch}
                            initialFilters={state.filters.searchFilters}
                            clearLoading={state.clearLoading}
                            searchLoading={state.searchLoading}
                            setLoadingType={(loadingType) => { loadingTypeReference.current = loadingType }}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <List
                            dispatch={dispatch}
                            items={state.items}
                            totalCount={state.totalCount}
                            initialPagination={state.filters.pagination}
                            loading={state.loading}
                            errorMessage={errorMessage}
                            selectVoter={selectVoter}
                            setLoadingType={(loadingType) => { loadingTypeReference.current = loadingType }}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default SelectVoter;